<template>
    <component v-bind:is="table" v-bind:items="items" ref="report"></component>
</template>

<script>
    import TableMonth from '@/components/elements/TableReportCommissionOfMonthsByMonth';
    import TableRange from '@/components/elements/TableReportCommissionOfMonthsByRange';
    export default {
        components: {
            "table-month": TableMonth,
            "table-range": TableRange
        },
        computed: {
            table: {
                get() {
                    if (this.date_type.id == "month") {
                        return 'table-month';
                    } else {
                        return 'table-range';
                    }
                }
            }
        },
        methods: {
            reportData() {
                return this.$refs.report.reportData();
            },
        },
        data() {
            return {
                name: null,
                status: null
            };
        },
        mounted() {
            var self = this;
        },
        props: ['date_type', 'items']
    };
</script>
